import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { themeTabs } from '@/mocks/home';

export default function ThemesSection() {
  const [activeKey, setActiveKey] = useState<string>(themeTabs[0].key);
  const active = themeTabs.find((tab) => tab.key === activeKey) ?? themeTabs[0];

  return (
    <section id="themes" className="border-t border-background-200 bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-5xl">
        <SectionHeading
          eyebrow="主题解读"
          title="四个角度，读懂它在讲什么"
          desc="从情感关系、群像叙事、悬念铺陈到视听语言，换一副眼镜看这部剧，很多细节会突然对上。"
          align="center"
        />

        <div className="reveal mt-8 flex flex-wrap justify-center gap-2 md:mt-10">
          {themeTabs.map((tab) => {
            const isActive = tab.key === activeKey;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveKey(tab.key)}
                aria-pressed={isActive}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'border border-background-300 bg-background-50 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <article className="reveal mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 md:grid-cols-[0.85fr_1.15fr]">
            <div className="flex flex-col justify-center gap-4 bg-primary-500 p-6 md:p-8">
              <i className="ri-double-quotes-l text-3xl text-accent-300" aria-hidden="true"></i>
              <p className="font-heading text-lg font-bold leading-relaxed text-background-50 md:text-2xl">
                {active.title}
              </p>
            </div>
            <div className="p-6 md:p-8">
              <p className="text-sm leading-8 text-foreground-700 md:text-base md:leading-9">
                {active.intro}
              </p>
              <ul className="mt-5 space-y-3">
                {active.points.map((point) => (
                  <li key={point} className="flex items-start gap-3">
                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-check-line text-xs text-accent-800" aria-hidden="true"></i>
                    </span>
                    <span className="text-sm leading-7 text-foreground-600">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}